import algoliasearch from "algoliasearch/lite";

const ALGOLIA_SEARCH_TAG_WEBAPP = "webapp";
const ALGOLIA_SEARCH_HITS_PER_PAGE = 1000;

export class SearchClient {
  constructor(tenantId, algoliaPublicKey, userSearchOptions) {
    this.searchClient = algoliasearch(process.env.REACT_APP_ALGOLIA_APP_ID, algoliaPublicKey);
    this.tenantId = tenantId;
    this.itemsIndex = this.searchClient.initIndex("items");
    this.searchFilter = this.buildSearchFilterQuery(userSearchOptions); // the filter string
    this.searchOptions = this.buildSearchOptions(); // the full search params, needs to be called after searchFilter is set up
  }

  /**
   * Reset search making sure there's not just cached results
   */
  clear() {
    if (this.searchClient) {
      this.searchClient.clearCache();
    }
  }

  /**
   * Get all the items from the index with an empty search
   * taking into consideration any user search filters (eg region)
   */
  async getAllItems() {
    return this.searchItems("");
  }


  /**
   * Search the items index
   * @param {String} searchString 
   * @returns 
   */
  async searchItems(searchString) {
    if (!this.itemsIndex) {
      return [];
    }

    let items = []; 
    // console.log({searchOptions:this.searchOptions});
    await this.itemsIndex.search(searchString, this.searchOptions)
      .then(({ hits }) => {
        items = hits;
      })
      .catch(err => {
        console.log(err);
      });
    
    return items;
  }

  /**
   * Given user search options, then update the filter string and search client params
   * @param {Object} userSearchOptions 
   */
  updateSearchOptions(userSearchOptions) {
    this.searchFilter = this.buildSearchFilterQuery(userSearchOptions);
    this.searchOptions = this.buildSearchOptions(); // needs to be called after searchFilter is set up
  }

  /**
   * Given the user search options, build the default query
   * @param {Object} userSearchOptions 
   * @returns 
   */
  buildSearchFilterQuery(userSearchOptions) {
    const filterOptions = userSearchOptions;
    let filters = [];
    if (!filterOptions) {
      return filters;
    }
    
    const funnels = filterOptions.funnelStage ? filterOptions.funnelStage.map(t => `funnelStage:"${t}"`) : [];
    const types = filterOptions.contentType ? filterOptions.contentType.map(t => `contentType:"${t}"`) : [];
    const tags = filterOptions.tags ? filterOptions.tags.map(t => `_tags:"${t}"`) : [];
    const products = filterOptions.products ? filterOptions.products.map(p => `contentProduct:"${p}"`) : [];
    const industries = filterOptions.industries ? filterOptions.industries.map(i => `contentIndustry:"${i}"`) : [];
    const regions = filterOptions.regions ? filterOptions.regions.map(r => `contentRegion:"${r}"`) : [];
    filters = [funnels.join(" OR "), types.join(" OR "), tags.join(" OR "), products.join(" OR "), industries.join(" OR "), regions.join(" OR ")];
    return filters.filter(ft => ft !== '').join(" AND ");
  }

  /**
   * Build the full search params
   * Note: this has to be called after the userSearchOptions have been built
   * @returns Object searchOptions
   */
  buildSearchOptions() {
    const searchOptions = {
      analyticsTags: [ this.tenantId, ALGOLIA_SEARCH_TAG_WEBAPP],
      hitsPerPage: ALGOLIA_SEARCH_HITS_PER_PAGE
    };

    if (this.searchFilter && this.searchFilter.length > 0) {
      searchOptions.filters = this.searchFilter;
    }

    return searchOptions;
  };

  //static 
  static getClient(tenantId, algoliaPublicKey, userSearchOptions) {
    if (!this.instance || (tenantId && this.tenantId !== tenantId)) {
      // console.log('updated tenant id__________: ', tenantId)

      if (!tenantId || !algoliaPublicKey) {
        this.instance = null;
        return null;
      }

      this.instance = new SearchClient(tenantId, algoliaPublicKey, userSearchOptions);
    } else if (userSearchOptions) {
      this.instance.updateSearchOptions(userSearchOptions);
    }

    return this.instance;
  }
}